import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, OnInit, inject, viewChild } from '@angular/core';
import { MatDrawer, MatDrawerContainer, MatDrawerContent } from '@angular/material/sidenav';
import { RouterOutlet } from '@angular/router';
import { AuthHeaderComponent } from 'app/core/auth-header/auth-header.component';
import { SidebarComponent } from 'app/core/sidebar/sidebar.component';

@Component({
  selector: 'app-layout-client',
  imports: [
    RouterOutlet,
    SidebarComponent,
    MatDrawerContainer,
    MatDrawer,
    MatDrawerContent,
    AuthHeaderComponent,
  ],
  templateUrl: './layout-client.component.html',
  styleUrl: './layout-client.component.scss',
  standalone: true,
})
export class LayoutClientComponent implements OnInit {
  private breakpointObserver = inject(BreakpointObserver);
  readonly drawer = viewChild(MatDrawer);
  drawerMode: 'over' | 'side' | 'push' = 'push';
  drawerOpened = true;
  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.Small, Breakpoints.XSmall]).subscribe((result) => {
      if (result.matches) {
        // Écran tablette ou mobile
        this.drawerOpened = false;
        this.drawerMode = 'over';
      } else {
        // Écran large
        this.drawerOpened = true;
        this.drawerMode = 'side';
      }
    });
  }
}
